import { Block, Button, Icon } from "framework7-react";
import { useToast } from "../../hooks/use-toast";
import {
  CSV_MIME_TYPE,
  buildExpensesCsv,
  csvFileName,
} from "../../utils/expenses-csv";
import { getSettlementShareText } from "../../utils/settlement-text";
import {
  SHARE_RESULT,
  downloadFile,
  shareOrCopyText,
  shareOrDownloadFile,
} from "../../utils/share";

const SettlementActions = ({ group }) => {
  const { showInfo, showError } = useToast();
  const title = `Abrechnung ${group?.name ?? ""}`.trim();

  const shareSettlement = async () => {
    try {
      const result = await shareOrCopyText({
        title,
        text: getSettlementShareText(group, new Date(), window.location.origin),
      });
      if (result === SHARE_RESULT.copied) showInfo("Abrechnung kopiert");
    } catch (error) {
      showError("Teilen nicht möglich");
    }
  };

  const exportCsv = async () => {
    try {
      const file = new File(
        [buildExpensesCsv(group)],
        csvFileName(group?.name),
        {
          type: CSV_MIME_TYPE,
        },
      );
      let result = await shareOrDownloadFile(file, { title });
      if (result === SHARE_RESULT.needsGesture) {
        downloadFile(file);
        result = SHARE_RESULT.downloaded;
      }
      if (result === SHARE_RESULT.downloaded) showInfo("CSV heruntergeladen");
    } catch (error) {
      showError("Export nicht möglich");
    }
  };

  return (
    <Block inset className="settlement-actions">
      <Button tonal className="settlement-share" onClick={shareSettlement}>
        <Icon ios="f7:square_arrow_up" md="material:share" size={20} />
        <span className="settlement-action-label">Abrechnung teilen</span>
      </Button>
      <Button tonal className="settlement-export" onClick={exportCsv}>
        <Icon ios="f7:arrow_down_doc" md="material:file_download" size={20} />
        <span className="settlement-action-label">Als CSV exportieren</span>
      </Button>
    </Block>
  );
};

export default SettlementActions;
